import React, { useEffect, useMemo, useState } from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { NoData, TabLayout } from 'src/@vymo/ui/blocks';
import classnames from 'classnames';
import { Keys, locale } from 'src/i18n';
import { getPerformanceCards } from 'src/models/lmsConfig/selectors';
import { useAppSelector } from 'src/store/hooks';
import { isLmsWeb } from 'src/workspace/utils';
import Dashboard from './dashboard/index';
import KeyMetrics from './keyMetrics';
import Leaderboard from './leaderboard/index';
import { PerformanceDashboardProps } from './types';
import styles from './index.module.scss';

function PerformanceWrapper({ tab }: PerformanceDashboardProps) {
  const performanceCards = useAppSelector(getPerformanceCards);
  const [performanceHeaderWidth, setPerformanceHeaderWidth] =
    useState<number>();

  useEffect(() => {
    const updateHeaderWidth = () => {
      const mainDiv = document.getElementById('main');
      setPerformanceHeaderWidth(mainDiv?.getBoundingClientRect?.().width);
    };

    updateHeaderWidth();
    window.addEventListener('resize', updateHeaderWidth);
    return () => window.removeEventListener('resize', updateHeaderWidth);
  }, []);

  const tabView = useMemo(() => {
    switch (tab) {
      case 'home':
        return <Dashboard />;
      case 'leaderboard':
        return <Leaderboard />;
      case 'key_metrics':
        return <KeyMetrics />;
      default:
        return <NoData message={locale(Keys.NO_MODULE_FOUND)} />;
    }
  }, [tab]);

  if (isLmsWeb()) {
    return (
      <div className={styles.performanceWebWrapper}>
        <div
          id="performanceHeader"
          className={styles.performanceWebWrapper__lmsWebHeader}
          style={{
            width: performanceHeaderWidth,
          }}
        >
          <Text type="h4" classNames={styles.performanceWebWrapper__title}>
            {locale(Keys.PERFORMANCE)}
          </Text>
          <TabLayout
            items={[
              { label: locale(Keys.DASHBOARD), key: 'home' },
              ...performanceCards.map((card) => ({
                label: card.title,
                key: card.code,
              })),
            ]}
            defaultKey={tab}
            onChange={(key) => {
              window.location.hash = `/performance/${key}`;
            }}
          />
        </div>
        <div
          className={classnames(
            styles.performanceWrapper,
            styles.performanceWrapper__lmsWebContent,
          )}
        >
          {tabView}
        </div>
      </div>
    );
  }

  return <div className={styles.performanceWrapper}>{tabView}</div>;
}

export default PerformanceWrapper;
